<template>
    <div>
        <section class="inner_banner character_inner_page">
            <!-- <div class="container-fluid">
              <h2 class="title">Characters Name</h2>
              <div class="charecter_single">
                <article class="row align-items-end">
                  <aside class="col-md-6">
                    <div class="charecter_single_img">
                      <img src="images/charecter-single.png" alt="">
                    </div>
                  </aside>
                  <aside class="col-md-6">
                    <div class="charecter_single_text">
                      <h4>Lorem Ipsum is simply dummy text </h4>
                      <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page.</p>
                      <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked.</p>
                      <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even</p>
                      <a href="#" class="btn_yellow">Buy Now</a>
                    </div>
                  </aside>
                </article>
              </div>
            </div> -->
        </section>
        <section class="character_inner">
            <div class="container-fluid">
                <article class="row align-items-center">
                    <aside class="col-md-5">
                        <div class="character_inner_img">
                            <img src="../assets/images/cb1.png" alt="">
                        </div>
                    </aside>
                    <aside class="col-md-7">
                        <div class="character_detail">
                            <h2 class="title">Sho Yukara</h2>
                            <p>"Sho Yukara embodies the power and resilience of the sumo when he fights. Much like how sumo wrestlers use their size and power to maintain a solid stance, Sho will refuse to give an inch to opponents, preferring to stand his ground and push back with overwhelming force. </p>
                            <p>Sho may not be as flexible or quick as other fighters, but his impregnable defence more than makes up for that. He’s got the stamina and the fortitude required to hold his ground against even the toughest of opponents - traits that will no doubt see him take many matches by storm."</p>
                            <div class="power_table">
                                <div class="table-responsive">
                                    <table>
                                        <tr>
                                            <th>Power</th>
                                            <td>3</td>
                                        </tr>
                                        <tr>
                                            <th>Health </th>
                                            <td>2</td>
                                        </tr>
                                        <tr>
                                            <th>Mobility </th>
                                            <td>3</td>
                                        </tr>
                                        <tr>
                                            <th>Techniques </th>
                                            <td>3</td>
                                        </tr>
                                        <tr>
                                            <th>Range </th>
                                            <td>3</td>
                                        </tr>
                                        <tr>
                                            <th>Speed</th>
                                            <td>1</td>
                                        </tr>
                                        <tr>
                                            <th>Avg.</th>
                                            <td>2</td>
                                        </tr>
                                        <tr>
                                            <th>Avg. bracket</th>
                                            <td>2</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <a href="#" class="btn_yellow">Buy Now</a>
                        </div>
                    </aside>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
export default {
name: "CharactersSingle"
}
</script>

<style scoped>

</style>
